import React from 'react';
class NotificationSVG extends React.Component {
    render() {
        return (<svg xmlns="http://www.w3.org/2000/svg" width="27.002" height="32" viewBox="0 0 27.002 32">
            <path id="Notification_Icon" data-name="Notification Icon" d="M7266,5194h-7a3,3,0,0,1,0-6h0v-10a9,9,0,0,1,8-8.945V5169a3,3,0,0,1,6,0c0,.075,0,.148-.009.221A9.006,9.006,0,0,1,7280,5178v10a3,3,0,1,1,0,6h-6a4,4,0,0,1-8,0Z" transform="translate(-7256.001 -5166)" fill="#fff" />
        </svg>
        )
    }
}
export default NotificationSVG